import useNotification from 'hooks/API/GET/useNotification';
import useManageNotification from 'hooks/API/useManageNotification';
import useToaster from 'hooks/useToaster';
import { useParams } from 'react-router-dom';
import NotificationHandleSection from './NotificationHandleSection';

function ManageNotification() {
  const { isLoading, mutate, isError } = useManageNotification();
  const { notificationID } = useParams();

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  const { data } = useNotification({
    enabled: !!notificationID,
    notificationID,
  });

  function handleNotification(notificationFormData = {}) {
    if (isLoading) return;

    mutate(notificationFormData);
  }

  return (
    <div className="mainWraper">
      <div className="container">
        <NotificationHandleSection
          handleNotification={handleNotification}
          preloadedData={data?.data ?? {}}
        />
      </div>
    </div>
  );
}

export default ManageNotification;
